export default __webpack_public_path__ + "static/media/Dark_Earnven_logo.745433e5.svg";